import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  // getCampaignList,
  getGridDataByModuleKey,
  getLeadById,
  getLeadList,
  getTagsByModule,
  getGeographyNodes,
  getOrgUnitNodes,
} from '../../redux/selector';
import {
  fetchDataAndUpdateStore,
  fetchNotesAndAppendToModule,
  fetchAttachmentsAndAppendToModule,
  fetchCampaignsAndAppendToModule,
  fetchEmailAndAppendToModule,
  fetchTagsAndAppendToModule,
  fetchDetailAndAppendToModule,
} from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { DetailDateFormatter } from '../../shared/controls/formatters';
import apiServices from '../../services/service';
import { toast } from 'react-toastify';
import Loader from '../../shared/component/Loader';
import Notes from '../sharedChild/note/notes';
import Attachments from '../sharedChild/attachment/attachments';
import Email from '../sharedChild/email/emails';
import ChildCampaign from '../sharedChild/childCampaign';
import { leadInputData } from '../../shared/constants';
import MassEmail from './massEmail';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Timeline from '../sharedChild/timeline';
import LeadCallModal from './LeadCallModal';
import LeadWhatsAppModal from './LeadWhatsAppModal';
import ComposeEmail from '../sharedChild/email/compose';
import Enrichment from './leadEnrichment';

const validationSchema = Yup.object().shape({
  businessType: Yup.string().required('Business Type is required'),
  industry: Yup.string().required('Industry is required'),
});

/* ---------- GrowthOS lead-record icons (stroke, 24×24) ---------- */
const ICONS = {
  grid: <path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z" />,
  clock: (<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  checkCircle: (<><circle cx="12" cy="12" r="9" /><path d="M8.5 12l2.5 2.5 4.5-5" /></>),
  circle: <circle cx="12" cy="12" r="9" />,
  note: <path d="M14 3v5h5M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-5ZM8 13h8M8 17h5" />,
  opportunity: <path d="M3 3v18h18M7 14l3-3 4 4 5-6" />,
  refresh: <path d="M21 12a9 9 0 1 1-3-6.7L21 8M21 3v5h-5" />,
  paperclip: <path d="M21 8l-9 9a5 5 0 0 1-7-7l9-9a3.5 3.5 0 0 1 5 5l-9 9a2 2 0 0 1-3-3l8-8" />,
  campaigns: <path d="M3 11v2a1 1 0 0 0 1 1h2l4 4V6L6 10H4a1 1 0 0 0-1 1ZM15 8a4 4 0 0 1 0 8M18 5a8 8 0 0 1 0 14" />,
  mail: <path d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2ZM22 7l-10 6L2 7" />,
  building: <path d="M3 21h18M6 21V4h9v17M9 8h3M9 12h3M9 16h3M15 21V9h4v12" />,
  users: (<><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13A4 4 0 0 1 16 11" /></>),
  location: (<><path d="M12 21s-7-6.5-7-11a7 7 0 0 1 14 0c0 4.5-7 11-7 11Z" /><circle cx="12" cy="10" r="2.5" /></>),
  info: (<><circle cx="12" cy="12" r="9" /><path d="M12 16v-4M12 8h.01" /></>),
  briefcase: <path d="M3 7h18v13H3zM8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />,
  phone: <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3-8.6A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.6a2 2 0 0 1-.5 2.1L8.1 9.9a16 16 0 0 0 6 6l1.5-1.2a2 2 0 0 1 2.1-.5c.8.3 1.7.6 2.6.7a2 2 0 0 1 1.7 2z" />,
  whatsapp: <path d="M12 2a9.9 9.9 0 0 0-8.4 15.2L2 22l4.9-1.5A10 10 0 1 0 12 2zM9 8c.3-.8 1.5-.8 1.8 0l.5 1.3c.1.4 0 .8-.3 1l-.6.5c.6 1.2 1.4 2 2.6 2.6l.5-.6c.2-.3.6-.4 1-.3l1.3.5c.8.3.8 1.5 0 1.8-1.8.8-4 .3-5.8-1.5S8.2 9.8 9 8z" />,
  dots: <path d="M12 5h.01M12 12h.01M12 19h.01" />,
  chevL: <path d="M15 18l-6-6 6-6" />,
  edit: <path d="M12 20h9M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" />,
  zap: <path d="M13 2L3 14h7l-1 8 10-12h-7z" />,
  x: <path d="M18 6 6 18M6 6l12 12" />,
  globe: (<><circle cx="12" cy="12" r="9" /><path d="M2.5 12h19M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" /></>),
  tag: (<><path d="M20.6 13.4 11 3.8a2 2 0 0 0-1.4-.6H4a1 1 0 0 0-1 1v5.6a2 2 0 0 0 .6 1.4l9.6 9.6a2 2 0 0 0 2.8 0l4.6-4.6a2 2 0 0 0 0-2.8z" /><path d="M7.5 7.5h.01" /></>),
  link: <path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1.5 1.5M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1.5-1.5" />,
  user: (<><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>),
  globe2: (<><circle cx="12" cy="12" r="9" /><path d="M2.5 12h19" /></>),
  plus: <path d="M12 5v14M5 12h14" />,
  search: (<><circle cx="11" cy="11" r="7" /><path d="m21 21-4.3-4.3" /></>),
  check: <path d="M20 6 9 17l-5-5" />,
};
const Ic = ({ name, size = 16, className, style }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    {ICONS[name] || null}
  </svg>
);

const GOS_AVA_COLORS = ['#c96342', '#2e63a6', '#2c7a45', '#9a751c', '#6a4fae', '#b34480', '#54738f'];
const gosInitials = (name) =>
  String(name || '')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0] || '')
    .join('')
    .toUpperCase() || '?';
const gosAvaColor = (name) =>
  GOS_AVA_COLORS[
    String(name || '')
      .split('')
      .reduce((a, c) => a + c.charCodeAt(0), 0) % GOS_AVA_COLORS.length
  ];

const val = (v) => (v === 0 || v ? v : null);
// GeographyNode/OrgUnitNode display label — prefers a precomputed one off the lead, else looks up the id
const scopeNodeLabel = (nodes, id, precomputed) => {
  if (precomputed) return precomputed;
  const match = (nodes || []).find((n) => String(n.id) === String(id));
  return match ? `${match.nodeType} - ${match.name} - ${match.path}` : null;
};
// one info-card on the Overview tab
const InfoCard = ({ title, icon, rows }) => (
  <div className="gos-lr-card">
    <div className="gos-lr-card-head">
      <div className="gos-lr-card-title">
        <Ic name={icon} size={16} /> {title}
      </div>
    </div>
    <div className="gos-lr-card-rows">
      {rows.map(([label, value], i) => (
        <div className="gos-lr-drow" key={i}>
          <div className="gos-lr-dlabel">{label}</div>
          <div className={'gos-lr-dval' + (val(value) ? '' : ' muted')}>{val(value) ?? '—'}</div>
        </div>
      ))}
    </div>
  </div>
);
// one row in the sticky Details panel (icon + label + value)
const DetailRow = ({ icon, label, children }) => (
  <div className="gos-lr-drow">
    <div className="gos-lr-dlabel">
      <Ic name={icon} size={15} /> {label}
    </div>
    <div className="gos-lr-dval gos-lr-dval-right">{children ?? '—'}</div>
  </div>
);
const Placeholder = ({ icon, title, text }) => (
  <div className="gos-lr-card gos-lr-placeholder">
    <div className="gos-lr-ph-ic">
      <Ic name={icon} size={22} />
    </div>
    <div className="gos-lr-ph-title">{title}</div>
    <div className="gos-lr-ph-text">{text}</div>
  </div>
);

/* ---------- Lead tags editor (add / remove / create) ---------- */
const TAG_TONES = ['blue', 'green', 'amber', 'purple', 'rose', 'gray', 'red'];
// deterministic tone per tag name so colors stay stable across renders/loads
const toneFor = (name) =>
  TAG_TONES[
    String(name || '')
      .split('')
      .reduce((a, c) => a + c.charCodeAt(0), 0) % TAG_TONES.length
  ];
// a backend tag's `name` is stored as an array — normalize to a display string
const tagName = (t) => (Array.isArray(t?.name) ? t.name.join(', ') : t?.name || '');

const LeadTagEditor = ({ lead }) => {
  const dispatch = useDispatch();
  const library = useSelector(getTagsByModule('leads')) || [];
  const applied = lead?.tags || []; // [{ id, name:[...] }]
  const moduleId = lead?.id;

  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const [busy, setBusy] = useState(false);
  const wrapRef = useRef(null);
  const inputRef = useRef(null);

  // load the module's tag library so the "Apply tags" list is populated
  useEffect(() => {
    dispatch(
      fetchDataAndUpdateStore({ key: 'tagsByModule', inputData: 'Lead', storeKey: 'leads' })
    );
  }, [dispatch]);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
        setQ('');
      }
    };
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setOpen(false);
        setQ('');
      }
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    const t = setTimeout(() => inputRef.current?.focus(), 30);
    return () => {
      document.removeEventListener('mousedown', onDown);
      document.removeEventListener('keydown', onKey);
      clearTimeout(t);
    };
  }, [open]);

  const refreshTags = () => {
    dispatch(fetchTagsAndAppendToModule({ moduleName: 'Lead', id: moduleId }));
    dispatch(
      fetchDataAndUpdateStore({ key: 'tagsByModule', inputData: 'Lead', storeKey: 'leads' })
    );
  };

  const addTagByName = async (name) => {
    if (!moduleId || busy) return;
    setBusy(true);
    try {
      const res = await apiServices.createTags({
        tagName: [name],
        module: 'Lead',
        moduleId: [moduleId],
      });
      if (res.status === 200) {
        toast.success('Tag added successfully!', { position: 'top-right' });
        refreshTags();
      }
    } catch (err) {
      console.error('Error adding tag:', err);
      toast.error('Failed to add tag.', { position: 'top-right' });
    } finally {
      setBusy(false);
    }
  };

  const removeTag = async (tag) => {
    if (!moduleId || busy) return;
    setBusy(true);
    try {
      const res = await apiServices.deleteTagsByModuleId({
        id: [tag.id],
        module: 'Lead',
        moduleId: [moduleId],
      });
      if (res.status === 200) {
        toast.success('Tag removed successfully!', { position: 'top-right' });
        refreshTags();
      }
    } catch (err) {
      console.error('Error removing tag:', err);
      toast.error('Failed to remove tag.', { position: 'top-right' });
    } finally {
      setBusy(false);
    }
  };

  // toggle a library tag: remove if already applied, else add
  const toggleLibraryTag = (libTag) => {
    const name = tagName(libTag);
    const existing = applied.find((a) => tagName(a) === name);
    if (existing) removeTag(existing);
    else addTagByName(name);
  };

  const ql = q.trim();
  const filtered = ql
    ? library.filter((t) => tagName(t).toLowerCase().includes(ql.toLowerCase()))
    : library;
  const exact = library.some((t) => tagName(t).toLowerCase() === ql.toLowerCase());
  const nextTone = TAG_TONES[library.length % TAG_TONES.length];

  const create = () => {
    if (!ql || exact || busy) return;
    addTagByName(ql);
    setQ('');
    inputRef.current?.focus();
  };

  return (
    <div className="gos-lead-tags">
      <span className="gos-lead-tags-label">
        <Ic name="tag" size={13} /> Tags
      </span>
      {applied.map((t) => {
        const tone = toneFor(tagName(t));
        return (
          <span
            key={t.id}
            className="gos-lead-tag"
            style={{ background: `var(--gos-${tone}-bg)`, color: `var(--gos-${tone}-fg)` }}
          >
            <span className="gos-lt-dot" />
            {tagName(t)}
            <button
              type="button"
              className="gos-lt-x"
              title="Remove tag"
              onClick={() => removeTag(t)}
              disabled={busy}
            >
              <Ic name="x" size={13} />
            </button>
          </span>
        );
      })}
      <div className="gos-tag-add-wrap" ref={wrapRef}>
        <button
          type="button"
          className={'gos-tag-add' + (open ? ' on' : '')}
          onClick={() => setOpen((o) => !o)}
        >
          <Ic name="plus" size={14} /> Add tag
        </button>
        {open ? (
          <div className="gos-tag-pop">
            <div className="gos-tag-pop-search">
              <Ic name="search" size={14} />
              <input
                ref={inputRef}
                placeholder="Search or create…"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && ql && !exact) create();
                }}
              />
            </div>
            <div className="gos-tag-pop-label">{ql ? 'Matching tags' : 'Apply tags'}</div>
            <div className="gos-tag-pop-list">
              {filtered.length === 0 && !ql ? (
                <div className="gos-tag-pop-empty">No tags yet</div>
              ) : null}
              {filtered.map((t) => {
                const name = tagName(t);
                const on = applied.some((a) => tagName(a) === name);
                const tone = toneFor(name);
                return (
                  <button
                    type="button"
                    key={t.id}
                    className={'gos-tag-opt' + (on ? ' on' : '')}
                    onClick={() => toggleLibraryTag(t)}
                    disabled={busy}
                  >
                    <span className="gos-to-dot" style={{ background: `var(--gos-${tone}-fg)` }} />
                    {name}
                    <span className="gos-to-check">{on ? <Ic name="check" size={12} /> : null}</span>
                  </button>
                );
              })}
              {ql && filtered.length === 0 ? (
                <div className="gos-tag-pop-empty">No matches — create it below</div>
              ) : null}
            </div>
            {ql && !exact ? (
              <button type="button" className="gos-tag-create" onClick={create} disabled={busy}>
                <span
                  className="gos-tc-swatch"
                  style={{
                    background: `var(--gos-${nextTone}-bg)`,
                    border: `1px solid var(--gos-${nextTone}-fg)`,
                  }}
                />
                Create <strong>{`“${ql}”`}</strong>
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

const ViewLead = () => {
  const refs = {
    overview: useRef(null),
    attachments: useRef(null),
    campaigns: useRef(null),
    emails: useRef(null),
    timeline: useRef(null),
  };
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'leads');
  const [formData, setFormData] = useState({});
  const [errormsg, setErrorMsg] = useState({});
  const [formEdited, setFormEdited] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const [enrichedDataLoading, setEnrichedDataLoading] = useState(false);

  const [activeTab, setActiveTab] = useState('overview');
  const [menuOpen, setMenuOpen] = useState(false);
  const [callOpen, setCallOpen] = useState(false);
  const [waOpen, setWaOpen] = useState(false);
  const [emailOpen, setEmailOpen] = useState(false);
  const [sentData, setSentData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [scheduledData, setScheduledData] = useState([]);
  const [isEnrichedFlag, setIsEnrichedFlag] = useState(false);
  const leadList = useSelector(getLeadList);
  const gridData = useSelector(getGridDataByModuleKey('leads'));
  const geographyNodes = useSelector(getGeographyNodes);
  const orgUnitNodes = useSelector(getOrgUnitNodes);

  let hasUpdateCampaignPermission = true;
  let hasViewCampaignPermission = true;
  let userUIControlPermission = JSON.parse(
    localStorage.getItem('userUIControlPermission')
  )?.campaignmenu;

  if (userUIControlPermission) {
    hasViewCampaignPermission = userUIControlPermission?.campaignviewscreen
      ? userUIControlPermission.campaignviewscreen.canView
      : true;

    hasUpdateCampaignPermission = userUIControlPermission?.campaignupdatescreen
      ? userUIControlPermission.campaignupdatescreen.canView
      : true;
  }

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  const searchParams = new URLSearchParams(location.search);
  const leadID = searchParams.get('id');
  const [leadLocalData, setLeadLocalData] = useState(location.state || {});
  const leadStoreData = useSelector((state) => {
    const leadId = location.state?.id || leadID; // Use the pre-fetched `leadID`
    return getLeadById(state, leadId);
  });

  useEffect(() => {
    setLeadLocalData((prev) => ({ ...prev, ...leadStoreData }));
  }, [leadStoreData]);
  //   const leadLocalData = useSelector((state) => {
  //     if(location.state)
  //       return location.state;

  //   const leadId = leadID; // Use the pre-fetched `leadID`
  //   return getLeadById(state, leadId);
  // });

  const scrollToSection = (id) => {
    if (refs[id]?.current) {
      refs[id].current.scrollIntoView({
        behavior: 'smooth', // Smooth scrolling
        block: 'center', // Aligns the section close to the center
        inline: 'nearest',
      });

      // Slightly adjust the position to be a bit above the center
      setTimeout(() => {
        const offset = -50; // Adjust this value for how much higher you want
        const elementPosition =
          refs[id].current.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
      }, 300); // Adjust timeout if necessary for smoother behavior
    }
  };

  useEffect(() => {
    if (leadLocalData?.emails) {
      const { sent, draft, scheduled } = leadLocalData?.emails?.reduce(
        (acc, item) => {
          if (item.status === 'Sent') acc.sent.push(item);
          else if (item.status === 'Draft') acc.draft.push(item);
          else if (item.status === 'Scheduled') acc.scheduled.push(item);
          return acc;
        },
        { sent: [], draft: [], scheduled: [] }
      );

      setSentData(sent);
      setDraftData(draft);
      setScheduledData(scheduled);
    }
    if (leadLocalData?.isEnriched) {
      setIsEnrichedFlag(leadLocalData?.isEnriched);
    }
  }, [leadLocalData]);

  useEffect(() => {
    // Add event listener for Bootstrap tab changes
    const handleTabShown = (event) => {
      setActiveTab(event.target.getAttribute('href').replace('#', ''));
    };

    document
      .querySelectorAll('[data-bs-toggle="tab"]')
      .forEach((tab) => tab.addEventListener('shown.bs.tab', handleTabShown));

    return () => {
      // Cleanup event listeners
      document
        .querySelectorAll('[data-bs-toggle="tab"]')
        .forEach((tab) => tab.removeEventListener('shown.bs.tab', handleTabShown));
    };
  }, []);

  // const campaignListAll = useSelector(getCampaignList);
  const handleFormSubmit = () => {};

  const handleChange = (selectedOption, name) => {
    setSelectedOptions((prevState) => ({
      ...prevState,
      [name]: selectedOption,
    }));

    handleLookupDropDownChange(selectedOption.value, selectedOption, name);
  };
  const handleDropdownChange = (selectedId, e, name, displayName, flag) => {
    const selectedValue = e.currentTarget.textContent;

    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
      [displayName]: undefined,
    }));
    setFormData({
      ...formData,
      [name]: selectedId,
      [displayName]: selectedValue,
    });

    setFormEdited(true);
  };

  const handleLookupDropDownChange = (selectedId, selectedOption, name) => {
    const selectedValue = selectedOption.label;
    setErrorMsg((prevErrorMsg) => ({
      ...prevErrorMsg,
      [name]: undefined,
    }));

    const updatedFormData = {
      ...formData,
      [name]: selectedId,
      [`${name}Name`]: selectedValue,
    };
    if (name === 'revenueTypeId') {
      setFormData({
        ...formData,
        revenueTypeId: selectedId,
        revenueType: selectedValue,
      });

      setFormEdited(true);
    } else if (name === 'leadSourceId') {
      setFormData({
        ...formData,
        leadSourceId: selectedId,
        leadSource: selectedValue,
      });
      setFormEdited(true);
    } else if (name === 'industryId') {
      setFormData({
        ...formData,
        industryId: selectedId,
        industry: selectedValue,
      });
      setFormEdited(true);
    }
  };
  const handleSubmit = async (noteData) => {
    const updatedNoteData = {
      ...noteData,
      moduleId: location.state?.id,
      module: 'Lead',
    };

    if (noteData.type === 'edit') {
      apiServices
        .updateNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            closePopup6();
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: 'Lead',
                id: location.state?.id,
              })
            );
            setLoading(false);
            toast.success('Notes Updated successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    } else {
      apiServices
        .createNote(updatedNoteData)
        .then((response) => {
          if (response.status === 200) {
            dispatch(
              fetchNotesAndAppendToModule({
                moduleName: 'Lead',
                id: location.state?.id,
              })
            );
            setLoading(false);
            toast.success('Notes Added successfully!', {
              position: 'top-right',
            });
          } else {
            setLoading(false);
            const errorMessages = [];
            for (const key in response.errors) {
              if (response.errors.hasOwnProperty(key)) {
                const messages = response.errors[key];
                errorMessages.push(...messages);
              }
            }
            errorMessages.forEach((errorMessage) => {
              toast.error(errorMessage, { position: 'top-right' });
            });
          }
        })

        .catch((error) => {
          console.error('Error:', error, 'DataFormat:', formData);
          toast.error('An unexpected error occurred.', {
            position: 'top-right',
          });
          setLoading(false);
        });
    }
  };

  const handleClickOpenConvertLead = () => {
    navigate('/leads/convertLead', {
      state: formData,
    });
  };
  const [isExpand, setIsExpand] = useState(false);

  const handleExpand = () => {
    setIsExpand((prev) => !prev);
  };

  const [image, setImage] = useState(null);
  const [imageName, setImageName] = useState('');
  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setImage(e.target.result); // Set the uploaded image URL
        setImageName(file.name); // Set the name of the uploaded image
        setIsMenuVisible(true); // Show the menu after the upload
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEditClick = () => {
    document.getElementById('image-upload-input').click(); // Trigger file input click
  };
  const handleRemoveImage = () => {
    setImage(null); // Clear the image
    setImageName(''); // Clear the image name
    setIsMenuVisible(false); // Hide the menu when the image is removed
  };
  const [selectedLink, setSelectedLink] = useState(null);
  const handleLinkClick = (link) => {
    // Set the clicked link as the selected one
    setSelectedLink(link);
  };

  // ______________________
  const [isOpen, setIsOpen] = useState(false);

  // State to control popup visibility
  const [showPopup, setShowPopup] = useState(false);

  // Function to handle opening the popup
  const openPopup = () => {
    setShowPopup(true);
  };

  const [showPopup4, setShowPopup4] = useState(false);
  const [showPopup5, setShowPopup5] = useState(false);
  const [showPopupLead, setShowPopupLead] = useState(false);
  const [leadEnrichedData, setLeadEnrichedData] = useState();
  const [showPopup6, setShowPopup6] = useState(false);

  // Function to open the fifth popup
  const openPopup5 = () => {
    setShowPopup5(true);
  };

  // Function to close the fifth popup
  const closePopup5 = () => {
    setShowPopup5(false);
    setShowPopup4(false);
  };

  // Function to open the fifth popup
  const openPopupLead = () => {
    setShowPopupLead(true);
  };

  // Function to close the fifth popup
  const closePopupLead = () => {
    setShowPopupLead(false);
  };

  const [showMassEmailPopup, setMassEmailPopup] = useState(false);

  const openMassEmailPopup = () => {
    setMassEmailPopup(true);
  };

  const closeMassEmailPopup = () => {
    setMassEmailPopup(false);
  };

  const [showSelectTemplatePopup, setSelectTemplatePopup] = useState(false);

  const openSelectTemplatePopup = () => {
    setSelectTemplatePopup(true);
  };

  const closeSelectTemplatePopup = () => {
    setSelectTemplatePopup(false);
  };

  // ______________________________table end_________

  const customStyles = {
    control: (base, state) => ({
      ...base,
      border: state.isFocused ? '2px solid transparent' : '1px solid transparent',
      borderRadius: '5px',
      boxShadow: state.isFocused ? 'none' : 'none',
      ':hover': {
        borderColor: 'transparent',
      },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#888',
      fontSize: '.8rem',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      display: 'none', // Hide the dropdown arrow
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: '#E7F2FF',
      borderRadius: '50px',
      padding: '5px 14px',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: '#707070',
      fontSize: '.8rem',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: '#4caf50',
      ':hover': {
        backgroundColor: '#d32f2f',
        color: '#fff',
      },
    }),
  };

  const closePopup6 = () => {
    setShowPopup6(false);
  };

  const openPopup6 = () => {
    setShowPopup6(true);
  };
  const handleOpenEditForm = (paramsValue) => {
    navigate('/leads/editLead', {
      state: formData,
    });
  };

  const [refreshLeadView, setRefreshLeadView] = useState(false);

  useEffect(() => {
    const leadId = location.state?.id || leadID;

    if (location.pathname.includes('viewLead')) {
      setFormData({
        ...leadLocalData,
        type: 'view',
        from: 'view',
      });
    }
    // if (leadList && leadList.length > 0 && leadId) {
    if (leadId) {
      dispatch(
        fetchDetailAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
          localDetail: location.state || null,
        })
      );
      dispatch(
        fetchNotesAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchAttachmentsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchCampaignsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchEmailAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
      dispatch(
        fetchTagsAndAppendToModule({
          moduleName: 'Lead',
          id: leadId,
        })
      );
    }
  }, [location, leadLocalData?.id, refreshLeadView]);

  const handleClickDelete = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      id: paramsValue.id,
    };
    console.log('Data==>>', data);
    apiServices
      .deleteNote(data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            fetchNotesAndAppendToModule({
              moduleName: 'Lead',
              id: location.state?.id,
            })
          );
          setLoading(false);
          toast.success('Note Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
      });
  };

  const handleClickDeleteCampaign = (paramsValue) => {
    setLoading(true);
    // Creating the desired JSON object
    const data = {
      moduleId: paramsValue.id,
      module: 'Lead',
    };
    console.log('Data==>>', data);
    apiServices
      .deleteCampaignByModule(data)
      .then((response) => {
        if (response.status === 200) {
          dispatch(
            fetchCampaignsAndAppendToModule({
              moduleName: 'Lead',
              id: location.state?.id,
            })
          );
          setLoading(false);
          toast.success('Campaign Deleted Successfully!', {
            position: 'top-right',
          });
        }
      })
      .catch((error) => {
        console.error('Error while deleting lead:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (showPopup5) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto'; // Cleanup
    };
  }, [showPopup5]);

  const handleClickDataEnrichment = (paramsValue) => {
    if (leadLocalData.firstName === '' || leadLocalData.lastName === '') {
      toast.error('Please fill in the first name and last name fields.', {
        position: 'top-right',
      });
      return;
    }
    setEnrichedDataLoading(true);

    // Creating the desired JSON object
    const data = {
      LeadName: `${leadLocalData.fullName}`,
      CompanyName: `${leadLocalData.companyName}`,
      EnrichmentType: 'leads',
    };

    const fetchEnrichedData = () => {
      apiServices
        .getEnrichedData(data)
        .then((response) => {
          if (response.status === 200) {
            console.log('Data==>>', response.data);
            setLeadEnrichedData(response.data?.enriched_data);
            setEnrichedDataLoading(false);
            openPopupLead();
            apiServices
              .updateEnrichedFlag(
                {
                  id: leadLocalData.id,
                },
                'Lead'
              )
              .then((res) => {
                if (res.status === 200) {
                  if (res.status === 200) {
                    setIsEnrichedFlag(true); // Set the enriched flag to true
                  }
                }
              })
              .catch((error) => {
                console.error('Error updating enriched flag:', error);
                toast.error('Failed to update enriched flag.', {
                  position: 'top-right',
                });
              });
          } else if (response.status === 202) {
            toast.info('Enrichment Initiated! Retrying in 2 minutes...', {
              position: 'top-right',
            });
            setTimeout(fetchEnrichedData, 120000); // Retry after 2 minutes
          }
        })
        .catch((error) => {
          console.error('Error while fetching enriched data:', error);

          // Safely extract error message from response
          const errorMsg = error?.response?.data?.error || 'An unexpected error occurred.';

          toast.error(errorMsg, {
            position: 'top-right',
          });

          setEnrichedDataLoading(false);
        });
    };

    fetchEnrichedData();
  };

  const handleUpdateForm = async (formData) => {
    setLoading(true);
    try {
      const response = await apiServices.updateLead(formData);

      if (response.status === 200) {
        // ✅ Await dispatch before toggling the refresh flag
        await dispatch(
          fetchDataAndUpdateStore({
            key: 'leads',
            inputData: gridData?.inputPayload ? gridData.inputPayload : leadInputData,
          })
        );

        setShowPopup5(false);
        setShowPopup4(false);
        closePopupLead();
        setLoading(false);

        // ✅ This now happens after dispatch is complete
        setRefreshLeadView((prev) => !prev);
      } else {
        setLoading(false);
        const errorMessages = [];
        for (const key in response.errors) {
          if (response.errors.hasOwnProperty(key)) {
            const messages = response.errors[key];
            errorMessages.push(...messages);
          }
        }
        errorMessages.forEach((errorMessage) => {
          toast.error(errorMessage, { position: 'top-right' });
        });
      }
    } catch (error) {
      console.error('Error:', error, 'DataFormat:', formData);
      toast.error('An unexpected error occurred.', {
        position: 'top-right',
      });
      setLoading(false);
    }
  };

  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      root: scrollContainerRef.current,
      rootMargin: '-200px 0px 0% 0px', // Adjusts the bottom margin to trigger when the section is halfway through the viewport
      threshold: 0,
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setActiveTab(sectionId);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe each section
    Object.values(refs).forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup on unmount
    return () => {
      observer.disconnect();
    };
  }, []);

  useEffect(() => {
    console.log('Active Tab:', activeTab);
  }, [activeTab]);

  return (
    <>
      {loading && <Loader />}

      <div className="ViewLeadPageOuter gos-leadrec">
        {(() => {
          const ld = leadLocalData || {};
          const geoScopeLabel = scopeNodeLabel(geographyNodes, ld.geoScopeNodeId, ld.geoScopeNode);
          const orgScopeLabel = scopeNodeLabel(orgUnitNodes, ld.orgScopeNodeId, ld.orgScopeNode);
          const fullName = ld.fullName || `${ld.firstName || ''} ${ld.lastName || ''}`.trim() || 'Lead';
          const cityState = [ld.city, ld.state].filter(Boolean).join(', ');
          const tzShort = ld.timeZone ? String(ld.timeZone).split(' ')[0] : '';
          const chips = [
            ld.leadSource && { icon: 'campaigns', label: ld.leadSource },
            cityState && { icon: 'location', label: cityState },
            tzShort && { icon: 'globe', label: tzShort },
            ld.businessType && { icon: 'tag', label: ld.businessType },
          ].filter(Boolean);
          const tabs = [
            { id: 'overview', label: 'Overview', icon: 'grid' },
            { id: 'activities', label: 'Activities', icon: 'clock' },
            { id: 'tasks', label: 'Tasks', icon: 'checkCircle' },
            { id: 'notes', label: 'Notes', icon: 'note', count: ld.notesList?.length },
            { id: 'opportunity', label: 'Opportunity Details', icon: 'opportunity' },
            { id: 'automation', label: 'Automation Runs', icon: 'refresh' },
            { id: 'attachments', label: 'Attachments', icon: 'paperclip', count: ld.attachments?.length },
            { id: 'campaigns', label: 'Campaigns', icon: 'campaigns', count: ld.campaigns?.length },
            { id: 'emails', label: 'Emails', icon: 'mail', count: ld.emails?.length },
          ];
          const detailsPanel = (
            <div className="gos-lr-card gos-lr-sticky">
              <div className="gos-lr-card-head">
                <div className="gos-lr-card-title">
                  <Ic name="info" size={16} /> Details
                </div>
                <button type="button" className="gos-lr-iconbtn" onClick={handleOpenEditForm} title="Edit lead">
                  <Ic name="edit" size={14} />
                </button>
              </div>
              <div className="gos-lr-sec">
                <div className="gos-lr-sec-title">Lead</div>
                <div className="gos-lr-card-rows">
                  <DetailRow icon="user" label="Name">{val(fullName)}</DetailRow>
                  <DetailRow icon="briefcase" label="Title">{val(ld.title)}</DetailRow>
                  <DetailRow icon="phone" label="Phone">{val(ld.phone || ld.mobile)}</DetailRow>
                  <DetailRow icon="mail" label="Email">
                    {ld.email ? <span className="gos-lr-link">{ld.email}</span> : '—'}
                  </DetailRow>
                  <DetailRow icon="location" label="City">{val(ld.city)}</DetailRow>
                  <DetailRow icon="globe" label="Region">{val(ld.state)}</DetailRow>
                  <DetailRow icon="campaigns" label="Source">{val(ld.leadSource)}</DetailRow>
                </div>
              </div>
              <div className="gos-lr-divider" />
              <div className="gos-lr-sec">
                <div className="gos-lr-sec-title">Company</div>
                <div className="gos-lr-card-rows">
                  <DetailRow icon="building" label="Company">{val(ld.companyName)}</DetailRow>
                  <DetailRow icon="briefcase" label="Industry">{val(ld.industry)}</DetailRow>
                  <DetailRow icon="tag" label="Revenue Type">{val(ld.revenueType)}</DetailRow>
                  <DetailRow icon="globe" label="Timezone">{val(ld.timeZone)}</DetailRow>
                  <DetailRow icon="link" label="Website">
                    {ld.website ? <span className="gos-lr-link">{ld.website}</span> : '—'}
                  </DetailRow>
                </div>
              </div>
            </div>
          );

          const overview = (
            <div className="gos-lr-grid2">
              <InfoCard
                title="Company Information"
                icon="building"
                rows={[
                  ['Company Name', val(ld.companyName)],
                  ['Industry', val(ld.industry)],
                  ['Website', val(ld.website)],
                  ['Business Type', val(ld.businessType)],
                  ['Employees', val(ld.noOfEmployees)],
                  ['Annual Revenue', val(ld.annualRevenue)],
                  ['OrgUnitNode', val(orgScopeLabel)],
                ]}
              />
              <InfoCard
                title="Contact Information"
                icon="users"
                rows={[
                  ['Full Name', val(fullName)],
                  ['Title', val(ld.title)],
                  ['Email', val(ld.email)],
                  ['Phone', val(ld.phone)],
                  ['Mobile', val(ld.mobile)],
                  ['Time Zone', val(ld.timeZone)],
                ]}
              />
              <InfoCard
                title="Lead Details"
                icon="info"
                rows={[
                  ['Lead Source', val(ld.leadSource)],
                  ['Owner', val(ld.owner)],
                  ['Revenue Type', val(ld.revenueType)],
                  ['Line of Business', val(ld.lineOfBusiness)],
                  ['Written Premium', val(ld.writtenPremium)],
                  ['Email Opt-out', ld.emailOptOut ? 'Yes' : 'No'],
                  ['Access Level', val(ld.accessLevel)],
                ]}
              />
              <InfoCard
                title="Address Information"
                icon="location"
                rows={[
                  ['Street', val(ld.street)],
                  ['City', val(ld.city)],
                  ['State', val(ld.state)],
                  ['Zip Code', val(ld.zipCode)],
                  ['Country', val(ld.country)],
                  ['LinkedIn', val(ld.contactLinkedIn)],
                  ['GeographyNode', val(geoScopeLabel)],
                ]}
              />
            </div>
          );

          let tabBody;
          if (activeTab === 'overview') tabBody = overview;
          else if (activeTab === 'activities')
            tabBody = <Timeline localData={leadLocalData} module={'Lead'} />;
          else if (activeTab === 'notes')
            tabBody = <Notes leadLocalData={leadLocalData} module={'Lead'} />;
          else if (activeTab === 'attachments')
            tabBody = <Attachments localData={leadLocalData} module={'Lead'} />;
          else if (activeTab === 'campaigns')
            tabBody = hasViewCampaignPermission ? (
              <ChildCampaign
                localData={leadLocalData}
                module={'Lead'}
                hasUpdateCampaignPermission={hasUpdateCampaignPermission}
              />
            ) : (
              <Placeholder icon="campaigns" title="Campaigns" text="You don't have permission to view campaigns for this lead." />
            );
          else if (activeTab === 'emails')
            tabBody = <Email localData={leadLocalData} module={'Lead'} />;
          else if (activeTab === 'tasks')
            tabBody = (
              <Placeholder icon="checkCircle" title="Tasks" text="Tasks and follow-ups for this lead will appear here." />
            );
          else if (activeTab === 'opportunity')
            tabBody = (
              <Placeholder icon="opportunity" title="Opportunity Details" text="Deal stages, products, quotes and forecast for this lead will appear here." />
            );
          else if (activeTab === 'automation')
            tabBody = (
              <Placeholder icon="refresh" title="Automation Runs" text="Automated sequences and workflow runs for this lead will appear here." />
            );

          return (
            <>
              {/* back row */}
              <div className="gos-lr-backrow">
                <button type="button" className="gos-lr-ghost-btn" onClick={() => navigate('/leads')}>
                  <Ic name="chevL" size={15} /> Leads list
                </button>
                {ld.id ? (
                  <div className="gos-lr-leadid">
                    Lead <span>{ld.id}</span>
                  </div>
                ) : null}
              </div>

              {/* header card */}
              <div className="gos-lr-card gos-lr-header">
                <div className="gos-lr-header-top">
                  <div className="gos-lr-header-l">
                    <span className="gos-lr-ava" style={{ background: gosAvaColor(fullName) }}>
                      {gosInitials(fullName)}
                    </span>
                    <div className="gos-lr-header-meta">
                      <div className="gos-lr-name">{fullName}</div>
                      <div className="gos-lr-subline">
                        <Ic name="briefcase" size={14} />
                        {[ld.title, ld.companyName].filter(Boolean).join(' · ') || '—'}
                        {ld.phone ? (
                          <>
                            <span className="gos-lr-dot">·</span>
                            <Ic name="phone" size={14} />
                            {ld.phone}
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  <div className="gos-lr-actions">
                    <button type="button" className="gos-lr-contact-btn" onClick={() => setCallOpen(true)}>
                      <Ic name="phone" size={16} /> Call
                    </button>
                    <button type="button" className="gos-lr-contact-btn" onClick={() => setWaOpen(true)}>
                      <Ic name="whatsapp" size={16} /> WhatsApp
                    </button>
                    <button
                      type="button"
                      className="gos-lr-contact-btn"
                      onClick={() => setEmailOpen(true)}
                      disabled={leadLocalData?.emailOptOut === true}
                    >
                      <Ic name="mail" size={16} /> Mail
                    </button>
                    <button
                      type="button"
                      className="gos-lr-iconbtn gos-lr-iconbtn-bordered"
                      onClick={() => setMenuOpen((o) => !o)}
                      aria-label="More actions"
                    >
                      <Ic name="dots" size={18} />
                    </button>
                    {menuOpen ? (
                      <>
                        <div className="gos-lr-menu-backdrop" onClick={() => setMenuOpen(false)} />
                        <div className="gos-lr-menu">
                          <button type="button" className="gos-lr-menu-item" onClick={() => { setMenuOpen(false); handleOpenEditForm(); }}>
                            <Ic name="edit" size={15} /> Edit Lead
                          </button>
                          <button
                            type="button"
                            className="gos-lr-menu-item"
                            onClick={() => { setMenuOpen(false); handleClickDataEnrichment(); }}
                            disabled={enrichedDataLoading}
                          >
                            <Ic name="zap" size={15} />
                            {leadLocalData?.isEnriched || isEnrichedFlag ? 'Refresh Enriched Data' : 'Get Enriched Data'}
                          </button>
                          <button type="button" className="gos-lr-menu-item gos-lr-menu-accent has-sep" onClick={() => { setMenuOpen(false); handleClickOpenConvertLead(); }}>
                            <Ic name="zap" size={15} /> Convert Lead
                          </button>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>
                {chips.length ? (
                  <div className="gos-lr-chips">
                    {chips.map((c, i) => (
                      <span className="gos-lr-chip" key={i}>
                        <Ic name={c.icon} size={14} /> {c.label}
                      </span>
                    ))}
                  </div>
                ) : null}
                <LeadTagEditor lead={ld} />
              </div>

              {/* tabs */}
              <div className="gos-lr-tabs">
                {tabs.map((t) => (
                  <button
                    key={t.id}
                    type="button"
                    className={'gos-lr-tab' + (activeTab === t.id ? ' active' : '')}
                    onClick={() => setActiveTab(t.id)}
                  >
                    <Ic name={t.icon} size={15} /> {t.label}
                    {t.count != null ? <span className="gos-lr-count">{t.count}</span> : null}
                  </button>
                ))}
              </div>

              {/* body */}
              {activeTab === 'overview' ? (
                overview
              ) : (
                <div className="gos-lr-2col">
                  <div className="gos-lr-main">{tabBody}</div>
                  {detailsPanel}
                </div>
              )}
            </>
          );
        })()}
      </div>

      {callOpen && <LeadCallModal lead={leadLocalData} onClose={() => setCallOpen(false)} />}
      {waOpen && <LeadWhatsAppModal lead={leadLocalData} onClose={() => setWaOpen(false)} />}
      {emailOpen && (
        <ComposeEmail
          localData={leadLocalData}
          module={'Lead'}
          handleClose={() => setEmailOpen(false)}
          handleChange={handleChange}
        />
      )}
      {showMassEmailPopup && <MassEmail handleClose={closeMassEmailPopup} />}

      {showPopupLead && (
        <Enrichment
          handleClose={closePopupLead}
          localData={leadLocalData}
          enrichedData={leadEnrichedData}
          handleSave={handleUpdateForm}
          loading={loading}
        />
      )}
    </>
  );
};

function TabContent({ data }) {
  return (
    <div className="tableContainer">
      <table>
        <thead>
          <tr>
            <th>
              <input type="checkbox" />
            </th>
            <th width="27.5%">Subject</th>
            <th>Message</th>
            <th>Date</th>
            <th>From Address</th>
            <th width="8%">Action</th>
          </tr>
        </thead>
        <tbody>
          {data?.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center' }}>
                No Records
              </td>
            </tr>
          ) : (
            data?.map((item) => (
              <tr key={item.id}>
                <td>
                  <input type="checkbox" />
                </td>
                <td className="cName">
                  <p>{item.subject}</p>
                </td>
                <td>{item.message}</td>
                <td>{DetailDateFormatter(item.scheduledTime)}</td>
                <td>
                  <a href={`mailto:${item.fromAddress}`} title="">
                    <span className="mailLink">{item.fromAddress}</span>
                  </a>
                </td>
                <td>
                  <div className="actionButton">
                    <img src="/assets/images/eye.png" alt="View" width="18px" />
                    <img src="/assets/images/editNotes.png" alt="Edit" width="14px" />
                    <img src="/assets/images/deleteNotes.png" alt="Delete" width="18px" />
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ViewLead;
